import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWaste: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconWaste"><Path d="M18.7 17.5L19.5 5.5L17.5 2.5H6.5L4.5 5.5L5.5 21.5H15" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 5.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M19 19.25C19 20.6307 17.8807 21.75 16.5 21.75C15.1193 21.75 14 20.6307 14 19.25C14 17.8693 15.1193 16.75 16.5 16.75C17.8807 16.75 19 17.8693 19 19.25Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconWaste;
